import { render } from "./HealthScorecardScreen.vue?vue&type=template&id=aab0fe64&scoped=true"
import script from "./HealthScorecardScreen.vue?vue&type=script&lang=js"
export * from "./HealthScorecardScreen.vue?vue&type=script&lang=js"

import "./HealthScorecardScreen.vue?vue&type=style&index=0&id=aab0fe64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aab0fe64"]])

export default __exports__